// ©2024 Austin App House. All rights reserved.
import React, { useEffect, useMemo, useState } from 'react';
import {
  MDBBtn,
  MDBCol,
  MDBIcon,
  MDBRow,
  MDBTable,
  MDBTableBody,
  MDBTableHead,
} from 'mdbreact';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import CheckInCheckOutFields from './checkInCheckOut';
import WorkOrderDetailsButtonControl from './WorkOrderDitalsButtonControl';
import Notification from '../../notification';
import IssueReports from './issueReports';
import ApproveWorkOrder from './approveWorkOrder';
import AppliedContractorDetails from './AppliedContractorDetails';
import InvitedContractorDetails from './InvitedContractorDetails';
import ApplicantCard from '../../layout/contractorCards/ApplicantCardDetails';
import WorkOrderHistory from './workOrderHistory';
import UploadDeliverables from './UploadDeliverables';
import WorkOrderExpenses from './expenses';
import ContractorTasks from './ContractorTasks';
import workOrderStatusControl from '../../../utils/workOrderStatusControl';
import { toggleModal, toggleSecondModalClose } from '../../../storage/actions/modalsActions';
import {
  deleteWorkOrderDetails,
  completeWorkOrder,
  editOnHoldStatusWorkOrder,
  createNewIssueReport,
  resolveIssueReport,
  sendIssueAgain,
  fetchApplicantsForWorkOrder,
  approvedWorkOrder,
  checkInCheckOutToWorkOrder,
  deleteCheckInCheckOutData,
  editCheckInCheckOutData,
  setCurrentApplicants,
  approvePayAdjustmentByContractor,
  deleteUpload, uploadDocument,
  saveExpense, editExpense, deleteExpense,
  cancelWorkOrder,
  assignContractor,
  saveApproveData,
  saveTasks,
  sendInviteFromWorkOrderToContractor,
  unRouteWorkOrder,
  createWorkOrderTemplateByWorkOrder,
  fetchWorkOrderById,
  acceptInvite,
  setDocumentsDownloadInProcess,
  changeCustomField
} from '../../../storage/actions/workOrdersActions';
import {
  sendBlockCompanyRequest,
  sendUnblockCompanyRequest,
} from '../../../storage/actions/profile';
import { localCurrencySettings } from '../../../utils/constans';
import PreviousApplicantsHistory from './previousApplicantsHistory';
import DeviceQty from './DeviceQty';
import isDeviceType from '../../../utils/isDeviceType';
import DocumentSection from './DocumentSection';
import ContentConfirmModalOnBlockCompanyByContractor
  from '../../layout/ContentConfirmModalOnBlockCompanyByContractor';
import ContractorExportWorkOrderButton from './ContractorExportWorkOrderButton';
import DashboardModalLoader from '../../dashboard/common/DashboardModalLoader';

const ViewDetailsWorkOrderModal = ({
  mainContainer,
  currentWorkOrder,
  auth,
  modalState,
  routedApplicants,
  applicants,
  currentWorkOrderLoaded,
  history, match,
  profile,
  activeTab,
  toggleModal, deleteWorkOrderDetails, editOnHoldStatusWorkOrder, completeWorkOrder,
  createNewIssueReport, resolveIssueReport, sendIssueAgain, fetchApplicantsForWorkOrder,
  approvedWorkOrder, checkInCheckOutToWorkOrder, uploadDocument,
  deleteCheckInCheckOutData, editCheckInCheckOutData, setCurrentApplicants, deleteUpload,
  approvePayAdjustmentByContractor, saveExpense, editExpense, deleteExpense, cancelWorkOrder,
  sendBlockCompanyRequest, sendUnblockCompanyRequest, assignContractor, saveApproveData, changeCustomField,
  saveTasks, toggleSecondModalClose, sendInviteFromWorkOrderToContractor,
  unRouteWorkOrder, createWorkOrderTemplateByWorkOrder, fetchWorkOrderById, acceptInvite, setDocumentsDownloadInProcess,
  documentsDownloadInProcess
}) => {
  const workOrderControlByStatus = currentWorkOrder
    ? workOrderStatusControl(currentWorkOrder.status)
    : {};
  const [tasks, changeStatusTasks] = useState({
    preArrivalRequirements: [],
    onSiteRequirements: [],
    completionRequirements: [],
  });
  const [qtyDevices, setQtyDevices] = useState();

  const requestedId = modalState?.type?.id;
  const requestedWin = modalState?.type?.win;
  const workOrderId = currentWorkOrder?._id;

  const blockedContractors = useMemo(() => {
    if (!workOrderId || (requestedId && workOrderId !== requestedId)) return [];
    return [
      ...(currentWorkOrder.blocked_users || []),
      ...((currentWorkOrder.companyNCR && currentWorkOrder.companyNCR.blocked_users) || []),
      ...((currentWorkOrder.projectInfo && currentWorkOrder.projectInfo.blocked_users) || []),
      ...((currentWorkOrder.woCompanyInfo && currentWorkOrder.woCompanyInfo.blocked_users) || []),
    ];
  }, [
    workOrderId,
    requestedId,
    currentWorkOrder?.blocked_users,
    currentWorkOrder?.companyNCR?.blocked_users,
    currentWorkOrder?.projectInfo?.blocked_users,
    currentWorkOrder?.woCompanyInfo?.blocked_users,
  ]);

  useEffect(() => {
    if (!modalState?.isOpen) return undefined;
    if (requestedId || requestedWin) {
      fetchWorkOrderById(requestedId, requestedWin, { skipGlobalLoader: true });
    }
    return undefined;
  }, [modalState?.isOpen, requestedId, requestedWin]);

  useEffect(() => {
    if (!workOrderId || (requestedId && workOrderId !== requestedId)) return undefined;
    if (currentWorkOrder?.tasks) changeStatusTasks(currentWorkOrder.tasks);
    setQtyDevices((prev) => (
      prev === currentWorkOrder?.qtyDevices ? prev : currentWorkOrder?.qtyDevices
    ));
    return undefined;
  }, [workOrderId, requestedId, currentWorkOrder?.tasks, currentWorkOrder?.qtyDevices]);

  const closeModal = () => {
    const tab = match.params.tab || activeTab || 'assigned';
    const pathname = `/dashboard/${tab}`;
    toggleModal(false, 'viewDetailsWorkOrderModal', true);
    toggleSecondModalClose('loader', true);
    try {
      history.replace({ pathname, search: '', hash: '' });
    } catch (_) {
      history.replace(pathname);
    }
  };

  const saveTasksHandler = async (newTasks) => {
    const { _id } = currentWorkOrder;
    await saveTasks(_id, newTasks);
    changeStatusTasks(newTasks);
  };

  const checkAllCheckbox = (data) => [
    ...data.preArrivalRequirements,
    ...data.onSiteRequirements,
    ...data.completionRequirements]
    .every((el) => el.checked === true);
  const completeWorkOrderHandler = (workOrderId, data, isDevice) => {
    if (!checkAllCheckbox(data)) {
      return Notification('warning', { message: 'Need finish required tasks!' });
    }
    if (isDevice && !(qtyDevices > 0)) {
      return Notification('warning', { message: 'Enter the number of devices' });
    }
    return completeWorkOrder(workOrderId, qtyDevices);
  };

  const showContractorProfile = contractorId => {
    toggleModal(true, 'contractorDetailsModal', true, { contractorId });
  };
  const changeCustomFieldValue = (customField) => {
    changeCustomField({ customField, workOrderId: currentWorkOrder._id })
  }

  const blockCompanyNCRByContractor = () => {
    toggleModal(true, 'confirmModal', true, {
      onAccept: () => sendBlockCompanyRequest(currentWorkOrder.companyId),
      header: `Block ${currentWorkOrder?.companyNCR?.name || 'NCR'}?`,
      content: <ContentConfirmModalOnBlockCompanyByContractor />,
      buttonLabels: {
        reject: 'Cancel',
        confirm: 'Yes, block',
      },
    });
  };

  const copyShareUrl = async () => {
    const { tab } = match.params;
    const url = window.location.origin + `/dashboard/${tab}?type=work-order&win=${currentWorkOrder.WIN}`

    await navigator.clipboard.writeText(url);

    Notification('success', { message: 'Copied successfully' });
  }

  if (!modalState?.isOpen) return null;

  const hasMatchingOrder = workOrderId
    && (!requestedId || workOrderId === requestedId);

  return (
      <div className="popup_block dashboard-modal dashboard-modal--order-details showed">
      <div className="popup_container order_details">
        <div className="popup_head">
          <button
            type="button"
            className="popup_title icon_share popup_title--btn"
            disabled={!hasMatchingOrder}
            aria-label="Copy share link"
            onClick={hasMatchingOrder ? copyShareUrl : undefined}
          >
            Work Order Details
          </button>
          <button
            type="button"
            className="close_btn"
            aria-label="close"
            onClick={closeModal}
          >
            ×
          </button>
        </div>

        <div className="popup_body dashboard-modal-order-details-scroll">
          {!hasMatchingOrder && <DashboardModalLoader />}
          {hasMatchingOrder && (
            <>
                    <div className="line_blocks">
                        <div className="order_title">
                            {currentWorkOrder.title}
                            <span className="order_status">
                                {auth.user.userType === 'contractor'
                                    && workOrderControlByStatus.beforeAssigned
                                    && !workOrderControlByStatus.canceled
                                    ? 'published'
                                    : currentWorkOrder.status}
                            </span>
                        </div>
                        <div className="by_order">
                            {auth.user.userType === 'contractor' ? 'Client' : 'Created By'}
                            {' '}
                            <span>{auth.user.userType === 'contractor'
                                ? currentWorkOrder.companyNCR.name
                                : currentWorkOrder.clientInfo?.name || currentWorkOrder.companyNCR.name}
                            </span>
                            <span>{`${currentWorkOrder?.clientInfo?.ratings || 100}%`}</span>
                        </div>
                        <div className="order_state">
                            <a
                                href='#'
                                type="button"
                                className="messages_btn"
                                onClick={(e) => {
                                    e.preventDefault();
                                    fetchApplicantsForWorkOrder(currentWorkOrder._id);
                                    toggleModal(true, 'workOrderMessageSystemModal', true, { workOrder: currentWorkOrder });
                                }}
                            >
                                Messages
                            </a>
                            {(currentWorkOrder?.city || currentWorkOrder?.state?.label || currentWorkOrder?.zipCode) && (
                                [currentWorkOrder?.city, currentWorkOrder?.state?.label, currentWorkOrder?.zipCode]
                                    .filter(Boolean)
                                    .join(', ')
                            )}
                        </div>
                        {/*<div className="by_order">*/}
                        {/*    {auth.user.userType === 'contractor' ? 'Client' : 'Created By'}*/}
                        {/*    {' '}*/}
                        {/*    <span>{auth.user.userType === 'contractor'*/}
                        {/*        ? currentWorkOrder.companyNCR.name*/}
                        {/*        : currentWorkOrder.clientInfo?.name || currentWorkOrder.companyNCR.name}*/}
                        {/*    </span>*/}
                        {/*    <span>{`${currentWorkOrder?.clientInfo?.ratings || 100}%`}</span>*/}
                        {/*</div>*/}
                        {currentWorkOrder.reasonToCancelWorkOrder
                            && workOrderControlByStatus.canceled && (
                                <div className="cancel_reason">
                                    Cancel reason: {currentWorkOrder.reasonToCancelWorkOrder}
                                </div>
                            )}
                        <ul className="order_list">
                            <li>
                                <span>WIN</span>
                                <span>{currentWorkOrder.WIN}</span>
                            </li>
                            <li>
                                <span>Company WO ID</span>
                                <span>{currentWorkOrder.customTagId}</span>
                            </li>
                            <li>
                                <span>Created Date</span>
                                <span>{new Date(currentWorkOrder.createdAt)
                                    .toLocaleDateString('en-US', { timeZone: 'UTC' })}
                                </span>
                            </li>
                            <li>
                                <span>Start Date</span>
                                <span>
                                    {new Date(currentWorkOrder.startDate).toLocaleDateString('en-US') === 'Invalid Date'
                                        ? ''
                                        : new Date(currentWorkOrder.startDate).toLocaleDateString('en-US')}
                                </span>
                                <span>End Date</span>
                                <span>
                                    {new Date(currentWorkOrder.endDate).toLocaleDateString('en-US') === 'Invalid Date'
                                        ? ''
                                        : new Date(currentWorkOrder.endDate).toLocaleDateString('en-US')}
                                </span>
                            </li>
                            <li>
                                <span>Start Time</span>
                                <span>{currentWorkOrder.startTime}</span>
                                <span>End Time</span>
                                <span>{currentWorkOrder.endTime}</span>
                            </li>
                        </ul>
                        <ul className="type_list">
                            {auth.user.userType === 'client' && (
                                <WorkOrderDetailsButtonControl
                                    currentWorkOrder={currentWorkOrder}
                                    deleteWorkOrderDetails={deleteWorkOrderDetails}
                                    editOnHoldStatusWorkOrder={editOnHoldStatusWorkOrder}
                                    toggleModal={toggleModal}
                                    fetchApplicantsForWorkOrder={fetchApplicantsForWorkOrder}
                                    createWorkOrderTemplateByWorkOrder={createWorkOrderTemplateByWorkOrder}
                                />
                            )}
                            {auth.user.userType === 'superAdmin'
                                && !workOrderControlByStatus.canceled && (
                                <li>
                                    <button
                                        type="button"
                                        color="secondary"
                                        className="primary_btn"
                                        onClick={() => {
                                            fetchApplicantsForWorkOrder(currentWorkOrder._id);
                                            toggleModal(false, 'viewDetailsWorkOrderModal', true);
                                            toggleModal(true, 'viewAllApplicantsForWorkOrderModal', true, {
                                                fromWorkOrderDetails: true,
                                            });
                                        }}
                                    >
                                        Applicants
                                    </button>
                                </li>
                            )}
                            {auth.user.userType === 'contractor'
                                && ['assigned', 'completed', 'approved', 'paid'].includes(currentWorkOrder.status) && (
                                    <li>
                                        <ContractorExportWorkOrderButton id={currentWorkOrder._id} />
                                    </li>
                                )}
                            {profile.userType === 'contractor' && !workOrderControlByStatus.beforeAssigned && (
                                <li>
                                    {currentWorkOrder?.contractorInfo?.blockedCompanies?.includes(currentWorkOrder.companyId) ? (
                                        <button
                                            type="button"
                                            className="block_type"
                                            onClick={() => sendUnblockCompanyRequest(currentWorkOrder.companyId)}
                                        >
                                            Unblock Client
                                        </button>
                                    ) : (
                                        <button
                                            type="button"
                                            className="block_type"
                                            onClick={blockCompanyNCRByContractor}
                                        >
                                            Block Client
                                        </button>
                                    )}
                                </li>
                            )}
                        </ul>
                    </div>

          <div className="detail_label">Offer Details</div>
          {currentWorkOrder.isNeedDeliverables && (
            <div className="line_blocks">
              <div className="notification_block">Upload Deliverables Required!</div>
            </div>
          )}
          <div className="line_blocks">
            <div className="block_label">Base Pay</div>
            <ul className="info_list">
              <li>
                <span>Amount</span>
                <span>
                  {(workOrderControlByStatus.beforeAssigned && !workOrderControlByStatus.canceled
                    ? currentWorkOrder.amount
                    : (currentWorkOrder.bidAmountBase || currentWorkOrder.amount))
                    .toLocaleString('en-US', localCurrencySettings)}
                </span>
                {currentWorkOrder.basicType && (
                  <>
                    <span>Per</span>
                    <span>
                      {currentWorkOrder.basicType === 'Hours'
                        ? 'Hour'
                        : currentWorkOrder.basicType}
                      {currentWorkOrder.basicType === 'Device'
                        ? ` (${currentWorkOrder.quantity && currentWorkOrder.quantity !== ''
                          ? currentWorkOrder.quantity
                          : '0'})`
                        : ''}
                    </span>
                  </>
                )}
              </li>
              <li>
                <span>Qty</span>
                <span>{currentWorkOrder.quantity}</span>
              </li>
              <li>
                <span>Est. Pay</span>
                <span>
                  {currentWorkOrder.potentialPay
                    ? currentWorkOrder.potentialPay.toLocaleString('en-US', localCurrencySettings)
                    : '$0.00'}
                  {currentWorkOrder.payBaseRateAsMinimum && (
                    <span className="special">MIN</span>
                  )}
                </span>
              </li>
            </ul>
          </div>
          <div className="line_blocks">
            <div className="block_label">How Pay is Divided</div>
            <ul className="info_list">
              <li>
                <span>Soft Skills</span>
                <span>
                  {currentWorkOrder.percentCommunication
                    && currentWorkOrder.percentCommunication !== ''
                    ? `${currentWorkOrder.percentCommunication}%`
                    : '0%'}
                </span>
              </li>
              <li>
                <span>Work</span>
                <span>
                  {currentWorkOrder.percentWork
                    && currentWorkOrder.percentWork !== ''
                    ? `${currentWorkOrder.percentWork}%`
                    : '0%'}
                </span>
              </li>
              <li>
                <span>Deliverables</span>
                <span>
                  {currentWorkOrder.percentDeliverables
                    && currentWorkOrder.percentDeliverables !== ''
                    ? `${currentWorkOrder.percentDeliverables}%`
                    : '0%'}
                </span>
              </li>
            </ul>
          </div>
          <div className="line_blocks">
            <div className="block_label">Variable Pay (optional)</div>
            <ul className="info_list">
              <li>
                <span>Amount</span>
                <span>
                  {(workOrderControlByStatus.beforeAssigned && !workOrderControlByStatus.canceled
                    ? currentWorkOrder.variableAmount || 0
                    : (currentWorkOrder.bidAmountVariable || currentWorkOrder.variableAmount || 0))
                    .toLocaleString('en-US', localCurrencySettings)}
                </span>
              </li>
              <li>
                <span>After</span>
                <span>{currentWorkOrder.variablePayAfter || 0}</span>
              </li>
              <li>
                <span>Max Qty</span>
                <span>{currentWorkOrder.maxQuantity || 0}</span>
              </li>
            </ul>
            {currentWorkOrder.payOutsideOfApp && (
              <div className="info_notice">Paid Outside of Wurqly Directly by Client!</div>
            )}
          </div>

          <div className="detail_label">Location</div>
          <div className="line_blocks">
            <ul className="info_list">
              <li>
                <span>Site ID</span>
                <span>{currentWorkOrder.siteId}</span>
              </li>
              <li>
                <span>Project</span>
                <span>{currentWorkOrder?.projectInfo?.name || ''}</span>
              </li>
              <li>
                <span>Site Name</span>
                <span>{currentWorkOrder.siteName}</span>
              </li>
              <li>
                <span>Company</span>
                <span>{currentWorkOrder?.woCompanyInfo?.name || ''}</span>
              </li>
              {(!workOrderControlByStatus.beforeAssigned || auth.user.userType !== 'contractor') && (
                <li>
                  <span>{[currentWorkOrder?.address1, currentWorkOrder?.address2]
                    .filter(Boolean)
                    .join(' ')}</span>
                </li>
              )}
              {(currentWorkOrder?.city || currentWorkOrder?.state?.label || currentWorkOrder?.zipCode) && (
                <li>
                  <span>
                    {[currentWorkOrder?.city, currentWorkOrder?.state?.label, currentWorkOrder?.zipCode]
                      .filter(Boolean)
                      .join(', ')}
                  </span>
                </li>
              )}
            </ul>
            {((!workOrderControlByStatus.beforeAssigned || auth.user.userType !== 'contractor')
              && !currentWorkOrder.isRemote) && (
                <button
                  type="button"
                  className="primary_btn"
                  onClick={() => toggleModal(true, 'googleMapsModal', true)}
                >
                  Google map
                </button>
              )}
            {currentWorkOrder.isRemote && (
              <div className="info_notice">Remote/WFH</div>
            )}
          </div>

          <div className="line_blocks">
            <div className="block_label">Work Description</div>
            <span>
              <div
                className="rich_text"
                dangerouslySetInnerHTML={{ __html: currentWorkOrder.description }}
              />
            </span>
          </div>

          <div className="line_blocks">
            <div className="block_label">Work Type</div>
            <span>
              {currentWorkOrder.workTypes && Array.isArray(currentWorkOrder.workTypes)
                ? currentWorkOrder.workTypes.map((tool, index) => (
                  <span key={tool._id || tool.id || `${tool.title}-${index}`} className="chip1">{tool.title}</span>
                ))
                : null}
            </span>
          </div>

          {currentWorkOrder.customTools && (
            <div className="line_blocks">
              <div className="block_label">Tools Required</div>
              <span>

                <div
                  className=""
                  dangerouslySetInnerHTML={{ __html: currentWorkOrder.customTools }}
                />
              </span>
            </div>
          )}

          {(!workOrderControlByStatus.beforeAssigned || auth.user.userType === 'client')
            && currentWorkOrder.confidential && (
              <div className="line_blocks">
                <div className="block_label">Confidential</div>
                <span>
                  <div
                    className="rich_text"
                    dangerouslySetInnerHTML={{ __html: currentWorkOrder.confidential }}
                  />
                </span>
              </div>
            )}

          {currentWorkOrder.customFields && currentWorkOrder.customFields.length > 0 && (
            <div className="line_blocks custom_fields">
              <div className="block_label">Custom Fields</div>
              <div className="table_wrapper">
                <MDBTable className="custom_table">
                  <MDBTableHead>
                    <tr>
                      <th>Name</th>
                      <th>Value</th>
                      <th />
                    </tr>
                  </MDBTableHead>
                  <MDBTableBody className="field_row">
                    {currentWorkOrder.customFields.map((sglOrd, index) => (
                      <tr key={sglOrd._id || `${sglOrd.name}-${index}`}>
                        <td className="field_name"><label>{sglOrd.name}</label></td>
                        {(sglOrd.type === 'RESTRICTED' || sglOrd.type === 'PUBLIC')
                          && auth.user.userType === 'contractor' ? (
                          <>
                            <td className="field_block">
                              <input
                                type="text"
                                name="description"
                                className="" placeholder="Type to add/change value"
                                defaultValue={sglOrd.value}
                                onChange={({ target }) => {
                                  sglOrd.value = target.value;
                                }}
                              />
                            </td>
                            <td>
                              <button
                                type="button"
                                className="dashboard-btn dashboard-btn--primary"
                                onClick={() => changeCustomFieldValue(sglOrd)}
                              >
                                Save
                              </button>
                            </td>
                          </>
                        ) : (
                          <td>{sglOrd.value}</td>
                        )}
                      </tr>
                    ))}
                  </MDBTableBody>
                </MDBTable>
              </div>
            </div>
          )}

          {tasks && tasks.preArrivalRequirements && (
            <div className="line_blocks">
              <div className="block_label">Pre-Arrival Requirements</div>
              <ContractorTasks
                section="preArrivalRequirements"
                tasks={tasks}
                handler={saveTasksHandler}
                isAssigned={workOrderControlByStatus.assigned}
              />
            </div>
          )}

          {tasks && tasks.onSiteRequirements && (
            <div className="line_blocks">
              <div className="block_label">On-Site Requirements</div>
              <ContractorTasks
                section="onSiteRequirements"
                tasks={tasks}
                handler={saveTasksHandler}
                isAssigned={workOrderControlByStatus.assigned}
              />
            </div>
          )}

          {tasks && tasks.completionRequirements && (
            <div className="line_blocks">
              <div className="block_label">Completion Requirements</div>
              <ContractorTasks
                section="completionRequirements"
                tasks={tasks}
                handler={saveTasksHandler}
                isAssigned={workOrderControlByStatus.assigned}
              />
            </div>
          )}

          <div className="line_blocks">
            <div className="block_label">Documents</div>
            <div className="fields_group">
              <DocumentSection
                documents={currentWorkOrder?.documents}
                userType={auth.user.userType}
                uploadDocument={uploadDocument}
                workOrderId={currentWorkOrder._id}
                contractorId={currentWorkOrder.contractor_id}
                documentVisibility={currentWorkOrder.documentVisibility}
                deleteUpload={deleteUpload}
                toggleModal={toggleModal}
                isWorkOrderCanceled={workOrderControlByStatus.canceled}
              />
            </div>
          </div>


          {!workOrderControlByStatus.beforeAssigned && (
            <CheckInCheckOutFields
              currentWorkOrder={currentWorkOrder}
              checkInOutDetails={currentWorkOrder.checkInOutDetails}
              userType={auth.user.userType}
              checkInCheckOutToWorkOrder={checkInCheckOutToWorkOrder}
              deleteCheckInCheckOutData={deleteCheckInCheckOutData}
              editCheckInCheckOutData={editCheckInCheckOutData}
            />
          )}

          {!workOrderControlByStatus.beforeAssigned && (
            <div className="line_blocks">
              <div className="fields_group">
                <UploadDeliverables
                  currentWorkOrder={currentWorkOrder}
                  auth={auth}
                  toggleModal={toggleModal}
                  deleteUpload={deleteUpload}
                  uploadDocument={uploadDocument}
                  documentsDownloadInProcess={documentsDownloadInProcess}
                  setDocumentsDownloadInProcess={setDocumentsDownloadInProcess}
                />
              </div>
            </div>
          )}

          {!workOrderControlByStatus.beforeAssigned && (
            // <div className="line_blocks">
            //     <div className="block_label">Expenses</div>
            //     <div className="fields_group">
            <WorkOrderExpenses
              auth={auth}
              currentWorkOrder={currentWorkOrder}
              saveExpense={saveExpense}
              editExpense={editExpense}
              deleteExpense={deleteExpense}
            />
            //     </div>
            // </div>
          )}

          {!workOrderControlByStatus.beforeAssigned && (
            <div className="line_blocks">
              <div className="block_label">Issue Reports</div>
              <div className="fields_group">
                <IssueReports
                  user={auth.user}
                  currentWorkOrder={currentWorkOrder}
                  createNewIssueReport={createNewIssueReport}
                  resolveIssueReport={resolveIssueReport}
                  sendIssueAgain={sendIssueAgain}
                />
              </div>
            </div>
          )}



          <div className="line_blocks">
            <div className="block_label">Actions</div>
            <div className="fields_group">
              {workOrderControlByStatus.assigned
                && currentWorkOrder.checkInOutDetails
                && currentWorkOrder.checkInOutDetails.length > 0
                && currentWorkOrder.checkInOutDetails[0].check_out_date && (
                  <>
                    {(!(!currentWorkOrder.isNeedDeliverables
                      || (currentWorkOrder.uploadDeliverables && currentWorkOrder.uploadDeliverables.length))) && (
                        <div className="info_notice">To Complete Upload Deliverables Required!</div>
                      )}
                    {isDeviceType(currentWorkOrder.basicType, currentWorkOrder.variableType, currentWorkOrder.variableAmount) && (
                      <DeviceQty value={qtyDevices} handler={setQtyDevices} />
                    )}
                    <div className="dashboard-modal-footer">
                      <button
                        color="info"
                        className="primary_btn"
                        onClick={() => {
                          const { _id } = currentWorkOrder;
                          const device = isDeviceType(
                            currentWorkOrder.basicType,
                            currentWorkOrder.variableType,
                            currentWorkOrder.variableAmount,
                          );
                          completeWorkOrderHandler(_id, tasks, device);
                        }}
                        disabled={
                          !(!currentWorkOrder.isNeedDeliverables
                            || (currentWorkOrder.uploadDeliverables && currentWorkOrder.uploadDeliverables.length))
                        }
                      >
                        Mark as Completed
                      </button>
                    </div>
                  </>
                )}
              {!workOrderControlByStatus.workUncompleted && !workOrderControlByStatus.canceled && (
                <ApproveWorkOrder
                  mainContainer={mainContainer}
                  auth={auth}
                  profile={profile}
                  currentWorkOrder={currentWorkOrder}
                  approvedWorkOrder={approvedWorkOrder}
                  approvePayAdjustmentByContractor={approvePayAdjustmentByContractor}
                  toggleModal={toggleModal}
                  toggleSecondModalClose={toggleSecondModalClose}
                  saveApproveData={saveApproveData}
                />
              )}
            </div>
          </div>

          {(auth.user.userType !== 'contractor' || !workOrderControlByStatus.beforeAssigned) && (
            <div className="line_blocks">
              <div className="block_label">Contact</div>
              <div className="table_wrapper">
                <table className="custom_table">
                  <thead>
                    <tr>
                      <th className="Name">Name</th>
                      <th className="Role">Role</th>
                      <th className="Phone">Office Phone</th>
                      <th className="Mobile">Mobile</th>
                      <th className="Email">Email</th>
                    </tr>
                  </thead>
                  {currentWorkOrder.contactInfo && (
                    <tbody>
                      {currentWorkOrder.contactInfo.map((sglOrd, index) => (
                        <tr key={sglOrd._id || sglOrd.id || `contact-${index}`}>
                          <td>{sglOrd.fname || ''}</td>
                          <td>{sglOrd.role || ''}</td>
                          <td>{sglOrd.ofc_phn || ''}</td>
                          <td>{sglOrd.mobile || ''}</td>
                          <td>{sglOrd.email || ''}</td>
                        </tr>
                      ))}
                    </tbody>
                  )}
                </table>
              </div>
            </div>
          )}

          {(auth.user.userType !== 'contractor')
            && !workOrderControlByStatus.beforeAssigned
            && currentWorkOrder.contractorInfo && (
              <div className="line_blocks">
                <div className="deployment_section">
                  <MDBTable className="applicantappiliedwo_table">
                    <MDBTableBody>
                      <ApplicantCard
                        userType={auth.user.userType}
                        contractorInfo={{
                          ...currentWorkOrder,
                          contractor_details: currentWorkOrder.contractorInfo,
                        }}
                        setCurrentApplicants={setCurrentApplicants}
                        toggleModal={toggleModal}
                        currentWorkOrder={currentWorkOrder}
                        assignContractor={assignContractor}
                      />
                    </MDBTableBody>
                  </MDBTable>
                </div>
              </div>
            )}

          {(auth.user.userType !== 'contractor')
            && workOrderControlByStatus.beforeAssigned
            && !workOrderControlByStatus.canceled && (
              <div className="line_blocks">
                <div className="fields_group">
                  <AppliedContractorDetails
                    userType={auth.user.userType}
                    applicants={applicants || []}
                    currentWorkOrder={currentWorkOrder}
                    toggleModal={toggleModal}
                    setCurrentApplicants={setCurrentApplicants}
                    assignContractor={assignContractor}
                  />
                  <InvitedContractorDetails
                    userType={auth.user.userType}
                    routedApplicants={routedApplicants}
                    toggleModal={toggleModal}
                    setCurrentApplicants={setCurrentApplicants}
                    currentWorkOrder={currentWorkOrder}
                    unRouteWorkOrder={unRouteWorkOrder}
                    acceptInvite={acceptInvite}
                  />
                </div>
              </div>
            )}

          {(auth.user.userType !== 'contractor') && currentWorkOrder?.applyHistory?.length ? (
            <div className="line_blocks">
              <PreviousApplicantsHistory
                applicants={currentWorkOrder.applyHistory}
                currentWorkOrder={currentWorkOrder}
                inviteContractor={sendInviteFromWorkOrderToContractor}
                blockedContractors={blockedContractors}
                showContractorProfile={showContractorProfile}
              />
            </div>
          ) : null}

          {(auth.user.userType !== 'contractor') && (
            <div className="line_blocks">
              <div className="block_label">Work Order History</div>
              <WorkOrderHistory history={currentWorkOrder.history} />
            </div>
          )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

const mapDispatchToProps = {
  toggleModal,
  deleteWorkOrderDetails,
  editOnHoldStatusWorkOrder,
  completeWorkOrder,
  createNewIssueReport,
  resolveIssueReport,
  sendIssueAgain,
  fetchApplicantsForWorkOrder,
  approvedWorkOrder,
  checkInCheckOutToWorkOrder,
  deleteCheckInCheckOutData,
  editCheckInCheckOutData,
  setCurrentApplicants,
  approvePayAdjustmentByContractor,
  uploadDocument,
  deleteUpload,
  saveExpense,
  editExpense,
  deleteExpense,
  cancelWorkOrder,
  sendBlockCompanyRequest,
  sendUnblockCompanyRequest,
  assignContractor,
  saveApproveData,
  saveTasks,
  changeCustomField,
  toggleSecondModalClose,
  sendInviteFromWorkOrderToContractor,
  unRouteWorkOrder,
  createWorkOrderTemplateByWorkOrder,
  fetchWorkOrderById,
  setDocumentsDownloadInProcess,
  acceptInvite
};

const mapStateToProps = (state) => ({
  currentWorkOrder: state.workOrder.currentWorkOrder,
  currentWorkOrderLoaded: state.workOrder.currentWorkOrderLoaded,
  routedApplicants: state.workOrder.routedApplicants,
  applicants: state.workOrder.applicants,
  documentsDownloadInProcess: state.workOrder.documentsDownloadInProcess,
  auth: state.auth,
  modalState: state.modalState.viewDetailsWorkOrderModal,
  profile: state.profile,
  activeTab: state.applicationState.activeTab,
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ViewDetailsWorkOrderModal));